/**
 * Aktywacja clientChooserSummarize() na document ready
 */
$(function () {
    clientChooserSummarize();
})

/**
 * Aktywacja clientChooseSummarize() na zmianę checkbox'a
     * Wysłanie ajaxa z aktualnym stanem zaznaczonych spółek
 */
$('body').on('change', '.dropdown-notification .client-checkbox', function (e) {
    var clientIds = [];

    $('.client-checkbox:checked').each(function () {
        clientIds.push($(this).val())
    })

    $.ajax({
        url: routes['app.client_user.sync_is_active'],
        type: 'post',
        data: {
            client_ids: clientIds
        },
        success: function () {
            $('[data-toggle="table"]').each(function () {
                $(this).bootstrapTable('refresh')
            })
            $(document).trigger('app.active-client-changer')
        },
        error: function () {
            showAlert(trans['client_user.error'], 'danger');
        },
        dataType: 'json'
    })

    clientChooserSummarize()
})

global.clientChooserSummarize = function clientChooserSummarize() {
    const countChecked = $('.client-checkbox:checked').length

    if (1 === countChecked) {
        $('.client-user-choices').text($('.client-checkbox:checked').data('name')).removeClass('no-choosen-client')
    } else if (1 < countChecked) {
        $('.client-user-choices').text(trans['user.clients_count'] + ' ' + countChecked).removeClass('no-choosen-client')
    } else {
        $('.client-user-choices').text(trans['user.no_client_choosen']).addClass('no-choosen-client')
    }
}
